import { run as runMailCheck } from 'mailcheck';
import { Nullable } from '../../../../../../models';
import { publicConfig } from '../../../../../../services';

function sift3Distance(s1: string, s2: string): number {
  if (s1 == null || s1.length === 0) {
    if (s2 == null || s2.length === 0) {
      return 0;
    } else {
      return s2.length;
    }
  }

  if (s2 == null || s2.length === 0) {
    return s1.length;
  }

  let c = 0;
  let offset1 = 0;
  let offset2 = 0;
  let lcs = 0;
  const maxOffset = 5;

  while (c + offset1 < s1.length && c + offset2 < s2.length) {
    if (s1.charAt(c + offset1) == s2.charAt(c + offset2)) {
      lcs++;
    } else {
      offset1 = 0;
      offset2 = 0;
      for (let i = 0; i < maxOffset; i++) {
        if (c + i < s1.length && s1.charAt(c + i) == s2.charAt(c)) {
          offset1 = i;
          break;
        }
        if (c + i < s2.length && s1.charAt(c) == s2.charAt(c + i)) {
          offset2 = i;
          break;
        }
      }
    }
    c++;
  }
  return (s1.length + s2.length) / 2 - lcs;
}

export const logSuggestion = (
  userEmail: string,
  suggestedEmail: string,
  selected?: boolean
) => {
  const formData = new FormData();

  formData.append('user_email', userEmail);
  formData.append('suggested_email', suggestedEmail);
  formData.append('region', publicConfig.REGION);
  if (selected) {
    formData.append('user_agreed', 'TRUE');
  }

  fetch(
    'https://script.google.com/macros/s/AKfycbyxjn8lXgAxY72XAx2u-eQMyTK0W8dbSkUW_iE3Dw0cuT4t-tYk381tqZ_JXG9HEB2y/exec',
    {
      method: 'POST',
      body: formData,
    }
  );
};

export const getEmailSuggestion = (
  value: string,
  onSuggested: (value: string) => void
) => {
  runMailCheck({
    email: value,
    domains: [
      'gmail.com',
      'mail.ru',
      'lerna.tech',
      'yandex.ru',
      'ya.ru',
      'bk.ru',
      'outlook.com',
      'hotmail.com',
      'rambler.ru',
      'icloud.com',
    ],
    topLevelDomains: [],
    secondLevelDomains: ['yandex'],
    distanceFunction: sift3Distance,
    suggested: function (suggestion: Nullable<{ full: string }>) {
      if (suggestion) {
        onSuggested(suggestion.full);
        logSuggestion(value, suggestion.full);
      }
    },
    empty: function () {
      // callback code
    },
  });
};
